module.exports = __webpack_public_path__ + "static/media/suhas_dode.eb952e9c.png";